$( document ).ready(function() {

  $('.main-menu-link-text').click(function() {
    console.log('clicked');
    console.log($(this).parent().attr('href'));
    //window.location.href = $(this).parent().attr('href');
  });

  //Child Menu is clicked
  $(document).on('click', '.has-children > .main-menu-link', function (e) {
    e.preventDefault();
    var menuIndex = $(this).attr('aria-controls');
    console.log(menuIndex);
    $('.child-menu-item.' + menuIndex).toggle();
  });

});